import { render, staticRenderFns } from "./MastHead.vue?vue&type=template&id=10a8c7a7&"
import script from "./MastHead.vue?vue&type=script&lang=ts&"
export * from "./MastHead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports